/**
 * Page orientation for shared PDF reports.
 */
export enum ReportPageOrientation {
  portrait = 'portrait',
  landscape = 'landscape',
}
